<template>
    <div class="user-level">
        <el-row>
            <el-col :span="24">
                <el-alert
                        title="温馨提示"
                        type="success"
                        close-text="知道了"
                        show-icon>
                    <p>好物官是指想分享以后，自己拿全部返利的人，不想让自己的下级拿返利</p>
                    <p>好物官绑定pid以后，下级购买，只有好物官有返利，下级没有返利</p>
                    <p>好物官pid，如果小程序包含3个平台，3个平台pid必须同时都设置</p>
                    <p style="color: #ff0036">如果出现误操作，某个用户点击了好物官小程序，看不到返利了，想让她恢复返利，则根据用户名查询好物官下级，然后删除即可</p>
                    <p><a href="https://www.yuque.com/yifakeji/irpssl/gf5qe4" target="_blank">点击查看好物官设置教程</a></p>
                </el-alert>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="formModel" class="search-area">
                    <el-form-item>
                        <el-input v-model="formModel.nickname" placeholder="请输入用户昵称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询好物官</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmitGroup">查询好物官下级</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="newUserLevel">新增用户</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="userLevels"
                        border
                        :key="userLevelsKey"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 255, 255, 0.5)"
                >
                    <el-table-column
                            label="用户id"
                            prop="id">
                    </el-table-column>
                    <el-table-column
                            label="用户">
                        <template slot-scope="scope">
                            <span>{{scope.row.nickname}}</span>
                            <img class="head-img" :src="scope.row.headPicUrl"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="openId"
                            prop="userName">
                    </el-table-column>
                    <el-table-column
                            label="淘宝pid"
                            prop="pid">
                    </el-table-column>
                    <el-table-column
                            label="拼多多pid"
                            prop="pddPid">
                    </el-table-column>
                    <el-table-column
                            label="京东推广位id"
                            prop="jdPid">
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="160">
                        <template slot-scope="scope">
                            <el-button @click="editRow(scope.row)" size="mini" class="edit-btn"
                                       v-if="scope.row.isMerchant==1">修改
                            </el-button>
                            <el-popover
                                    placement="right"
                                    width="160"
                                    v-model="scope.row.visible">
                                <p>确定删除吗？</p>
                                <div style="text-align: right; margin: 0">
                                    <el-button size="mini" type="info" @click="scope.row.visible=false">取消
                                    </el-button>
                                    <el-button type="danger" size="mini"
                                               @click="deleteRow(scope.$index,scope.row)">确定
                                    </el-button>
                                </div>
                                <el-button slot="reference" type="danger" size="mini">
                                    删除
                                </el-button>

                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="pageSize"
                            layout="total,prev, pager, next"
                            :total="totalCount">
                    </el-pagination>
                </div>

            </el-col>
        </el-row>
        <el-dialog title="增加用户" :visible.sync="newDialogShow">
            <el-row>
                <el-col :span="12">
                    <el-form :inline="true" :model="newFormModel" class="search-area">
                        <el-form-item>
                            <el-input v-model="newFormModel.keyword" placeholder="请输入用户昵称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getUsersForSetting">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-table
                    :data="newUserLevels"
                    ref="newUserLevelsTable"
                    highlight-current-row
                    @current-change="handleCurrentRow"
                    v-if="newUserLevels.length >0"
                    border>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        label="用户">
                    <template slot-scope="scope">
                        <span>{{scope.row.nickname}}</span>
                        <img class="head-img" :src="scope.row.headPicUrl"/>
                    </template>
                </el-table-column>
                <el-table-column
                        label="openId"
                        prop="userName">
                </el-table-column>
                <el-table-column
                        label="淘宝pid"
                        prop="pid">
                </el-table-column>
                <el-table-column
                        label="拼多多pid"
                        prop="pddPid">
                </el-table-column>
                <el-table-column
                        label="京东推广位id"
                        prop="jdPid">
                </el-table-column>
            </el-table>

            <el-form :model="currentNewRow" ref="newForm" label-position="right">
                <el-form-item label="淘宝pid" :label-width="100" prop="pid">
                    <el-input class="input-text" v-model="currentNewRow.pid"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="拼多多pid" :label-width="100" prop="pddPid">
                    <el-input class="input-text" v-model="currentNewRow.pddPid"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="京东推广位id" :prop="jdPid" :label-width="100">
                    <el-input class="input-text" v-model="currentNewRow.jdPid"
                              autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="newDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="saveNew('newForm')" v-loading.fullscreen.lock="saving">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改用户" :visible.sync="editDialogShow">
            <span>{{currentEditRow.nickname}}</span>
            <img class="head-img" :src="currentEditRow.headPicUrl"></img>
            <el-form :model="currentEditRow" ref="editForm" label-position="right">
                <el-form-item label="淘宝Pid" :label-width="100" prop="pid">
                    <el-input class="input-text" v-model="currentEditRow.pid"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="拼多多pid" :prop="pddPid" :label-width="100">
                    <el-input class="input-text" v-model="currentEditRow.pddPid"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="京东推广位id" :prop="jdPid" :label-width="100">
                    <el-input class="input-text" v-model="currentEditRow.jdPid"
                              autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit('editForm')" v-loading.fullscreen.lock="saving">确 定
                </el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import {userLeveInfoApi} from "../../common/userLeveInfoApi";
    import {userApi} from "../../common/userApi";

    export default {
        name: '',
        data() {
            return {
                users: [],
                userLevels: [],//用户级别
                newUserLevels: [], //查询出来待设置的用户级别
                newFormModel: {},
                formModel: {},
                currentTab: 'first',
                newDialogShow: false,
                editDialogShow: false,
                currentNewRow: {},
                currentEditRow: {},
                page: 1,
                pageSize: 10,
                totalCount: 0,
                userLevelsKey: 1,
                saving: false,
                loading: false
            }

        },
        watch: {
            newDialogShow() {
                ++this.userLevelsKey;
            }

        },
        created() {
            var that = this
            that.loading = true;
            userApi.getUsers.call(that, {
                isMerchant: 1,
                page: that.page,
                pageSize: that.pageSize,
                nickname: that.formModel.nickname
            }, function (res) {
                that.loading = false;
                if (res.result.items) {
                    that.userLevels = res.result.items;
                }
                if (res.result.totalCount) {
                    that.totalCount = res.result.totalCount
                }
            }, function () {
                that.loading = false;
            })

        },
        methods: {
            onSubmit() {
                var that = this
                that.page = 1
                that.formModel.isMerchant = 1
                userApi.getUsers.call(that, that.formModel, function (res) {
                    if (res.result.items) {
                        that.userLevels = res.result.items;
                    }
                    if (res.result.totalCount) {
                        that.totalCount = res.result.totalCount
                    }
                }, function (res) {
                    that.failMsg(res.msg)
                })

            },
            onSubmitGroup() {
                var that = this
                that.page = 1
                that.formModel.isMerchant = 5
                userApi.getUsers.call(that, that.formModel, function (res) {
                    if (res.result.items) {
                        that.userLevels = res.result.items;
                    }
                    if (res.result.totalCount) {
                        that.totalCount = res.result.totalCount
                    }
                }, function (res) {
                    that.failMsg(res.msg)
                })

            },
            editRow(row) {
                this.currentEditRow = row;
                this.editDialogShow = true;
            },
            deleteRow(index, row) {
                var that = this;
                row.isMerchant = 0
                userApi.cancelRebateAgentPid.call(that, row, function (res) {
                    that.successMsg("删除成功");
                    that.userLevels.splice(index, 1)

                })
            },
            newUserLevel() {
                this.newDialogShow = true;
                this.currentNewRow = {}
                this.newUserLevels = []
            },
            saveNew(formName) {
                var that = this
                that.saving = true;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.currentNewRow.isMerchant = 1
                        userApi.updateRebateAgentPid.call(that, that.currentNewRow, function (res) {
                            that.successMsg("操作成功")
                            that.saving = false;
                        }, function (res) {
                            that.saving = false;
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }

                });

            },
            saveEdit(formName) {
                var that = this
                that.saving = true;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.currentEditRow.isMerchant = 1
                        userApi.updateRebateAgentPid.call(that, that.currentEditRow, function (res) {
                            that.successMsg("操作成功")
                            that.saving = false;

                        }, function (res) {
                            that.saving = false;
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }

                });
            },
            getUsersForSetting() {
                var that = this;
                userApi.getUnionUsers.call(that, {nickname: that.newFormModel.keyword},
                    function (res) {
                        if (res.result.items) {
                            that.newUserLevels = res.result.items;
                            if (res.result.items.length == 1) {
                                that.currentNewRow = res.result.items[0]
                            }
                        }

                    },
                    function (res) {
                        console.log(res)
                    }
                )
            },

            handleCurrentRow(val) {
                this.currentNewRow = val;
            },
            handleCurrentChange() {
                var that = this;
                userApi.getUsers.call(that, {
                    isMerchant: 1,
                    page: that.page,
                    pageSize: that.pageSize,
                    nickname: that.formModel.nickname
                }, function (res) {
                    if (res.result.items) {
                        that.userLevels = res.result.items;
                    }
                    if (res.result.totalCount) {
                        that.totalCount = res.result.totalCount
                    }
                })
            }


        }
    }
</script>
<style lang="scss">

    .user-level {
        .search-area {
            text-align: left;
        }

        .head-img {
            width: 30px;
            height: 30px;
            vertical-align: middle;
            margin-left: 5px;
        }

        .edit-btn {
            margin-right: 5px;
        }

    }
</style>